export let subItemProps = {
    key: 0,
    id: 0,
    sub_variant_name: ''
}

export let dataProps = {
    id: 0,
    variant_name: '', 
    sub_item_list: [JSON.parse(JSON.stringify(subItemProps))],
    deleted_sub_item_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryVariant/properties.js